import { notification } from 'antd';
import { isRTL } from './language';
import { ReactNode } from 'react';

type NotificationType = 'success' | 'error' | 'info' | 'warning';

const openNotification = (type: NotificationType, message: string, description?: ReactNode) => {
	notification[type]({
		message,
		description,
		className: type,
		placement: isRTL() ? 'topLeft' : 'topRight',
	});
};

// Notification service with methods for each notification type
const NotificationService = {
	success: (message: string, description?: ReactNode) => openNotification('success', message, description),
	error: (message: string, description?: ReactNode) => openNotification('error', message, description),
	info: (message: string, description?: ReactNode) => openNotification('info', message, description),
	warning: (message: string, description?: ReactNode) => openNotification('warning', message, description),
};

export default NotificationService;
